import { generateUserAgentHeader, urls } from '~/utilities/dataHelpers';
import mediator from '~/utilities/mediator';

export const handleConsent = async ({
  patientId,
  appVersion,
  osType,
  osVersion,
  action,
  dataId,
  deviceId,
}: {
  patientId: string;
  action: string;
  osType: string;
  osVersion: string;
  appVersion: string;
  dataId: 'realWorldEvidence' | 'hipaa';
  deviceId: string;
}) => {
  const result = await mediator.request<ApiResponse<ConsentActionResponse>>(
    'api:invoke',
    {
      method: 'PUT',
      url: `${urls.apiUrl}patients/${patientId}/consents`,
      headers: {
        'X-User-Agent': generateUserAgentHeader({
          appVersion,
          osType,
          osVersion,
        }),
        'X-Device-ID': deviceId,
      },
      data: {
        id: dataId,
        action,
      },
    },
  );

  if (result.data) {
    return result.data;
  }

  throw result;
};
